import { Components, Theme } from '@mui/material/styles';

export const MuiSelect: Components<Theme>['MuiSelect'] = {
  styleOverrides: {
    root: {
    },
    icon: {
      color: 'var(--palette-primary-main)',
    },
  },
};
